import { contactEntry } from '@/mocks/home';

export default function SectionContact() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            <i className="ri-mail-send-line text-primary-500 mr-2"></i>
            {contactEntry.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {contactEntry.desc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 text-sm">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span className="text-foreground-700">{contactEntry.email}</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 text-sm">
              <i className="ri-wechat-line text-accent-500 text-lg"></i>
              <span className="text-foreground-700">{contactEntry.wechat}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}